$(document).on('focus', 'input.no-autofill[readonly]', function(e){ this.removeAttribute('readonly'); });
